"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DismissIcon = function DismissIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: (className || '') + '',
    focusable: false,
    height: "14",
    role: "presentation",
    viewBox: "0 0 14 14",
    width: "14",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.71094 7L13.1016 12.3984L12.3984 13.1016L7 7.71094L1.60156 13.1016L0.898438 12.3984L6.28906 7L0.898438 1.60156L1.60156 0.898438L7 6.28906L12.3984 0.898438L13.1016 1.60156L7.71094 7Z"
  }));
};

DismissIcon.defaultProps = {
  className: undefined
};
DismissIcon.propTypes = {
  className: _propTypes.default.string
};
var _default = DismissIcon;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Ub2FzdC9EaXNtaXNzSWNvbi5qcyJdLCJuYW1lcyI6WyJEaXNtaXNzSWNvbiIsImNsYXNzTmFtZSIsImRlZmF1bHRQcm9wcyIsInVuZGVmaW5lZCIsInByb3BUeXBlcyIsIlByb3BUeXBlcyIsInN0cmluZyJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUNBOzs7O0FBRUEsSUFBTUEsV0FBVyxHQUFHLFNBQWRBLFdBQWM7QUFBQSxNQUFHQyxTQUFILFFBQUdBLFNBQUg7QUFBQSxzQkFDbEI7QUFDRSxJQUFBLFNBQVMsRUFBRSxDQUFDQSxTQUFTLElBQUksRUFBZCxJQUFvQixFQURqQztBQUVFLElBQUEsU0FBUyxFQUFFLEtBRmI7QUFHRSxJQUFBLE1BQU0sRUFBQyxJQUhUO0FBSUUsSUFBQSxJQUFJLEVBQUMsY0FKUDtBQUtFLElBQUEsT0FBTyxFQUFDLFdBTFY7QUFNRSxJQUFBLEtBQUssRUFBQyxJQU5SO0FBT0UsSUFBQSxLQUFLLEVBQUM7QUFQUixrQkFTRTtBQUFNLElBQUEsQ0FBQyxFQUFDO0FBQVIsSUFURixDQURrQjtBQUFBLENBQXBCOztBQWNBRCxXQUFXLENBQUNFLFlBQVosR0FBMkI7QUFDekJELEVBQUFBLFNBQVMsRUFBRUU7QUFEYyxDQUEzQjtBQUlBSCxXQUFXLENBQUNJLFNBQVosR0FBd0I7QUFDdEJILEVBQUFBLFNBQVMsRUFBRUksbUJBQVVDO0FBREMsQ0FBeEI7ZUFJZU4sVyIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IERpc21pc3NJY29uID0gKHsgY2xhc3NOYW1lIH0pID0+IChcbiAgPHN2Z1xuICAgIGNsYXNzTmFtZT17KGNsYXNzTmFtZSB8fCAnJykgKyAnJ31cbiAgICBmb2N1c2FibGU9e2ZhbHNlfVxuICAgIGhlaWdodD1cIjE0XCJcbiAgICByb2xlPVwicHJlc2VudGF0aW9uXCJcbiAgICB2aWV3Qm94PVwiMCAwIDE0IDE0XCJcbiAgICB3aWR0aD1cIjE0XCJcbiAgICB4bWxucz1cImh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnXCJcbiAgPlxuICAgIDxwYXRoIGQ9XCJNNy43MTA5NCA3TDEzLjEwMTYgMTIuMzk4NEwxMi4zOTg0IDEzLjEwMTZMNyA3LjcxMDk0TDEuNjAxNTYgMTMuMTAxNkwwLjg5ODQzOCAxMi4zOTg0TDYuMjg5MDYgN0wwLjg5ODQzOCAxLjYwMTU2TDEuNjAxNTYgMC44OTg0MzhMNyA2LjI4OTA2TDEyLjM5ODQgMC44OTg0MzhMMTMuMTAxNiAxLjYwMTU2TDcuNzEwOTQgN1pcIiAvPlxuICA8L3N2Zz5cbik7XG5cbkRpc21pc3NJY29uLmRlZmF1bHRQcm9wcyA9IHtcbiAgY2xhc3NOYW1lOiB1bmRlZmluZWRcbn07XG5cbkRpc21pc3NJY29uLnByb3BUeXBlcyA9IHtcbiAgY2xhc3NOYW1lOiBQcm9wVHlwZXMuc3RyaW5nXG59O1xuXG5leHBvcnQgZGVmYXVsdCBEaXNtaXNzSWNvbjtcbiJdfQ==